<div class="card">
    <h5>Vertical</h5>
    <p-chart type="bar" [data]="basicData" [options]="basicOptions"></p-chart>
</div>

<app-video-player *ngIf="" videoURL="https://vjs.zencdn.net/v/oceans.mp4" posterURL=""></app-video-player>

<app-gallery-view></app-gallery-view>